// Generated from assets/EmptyState/winner_isometric1.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

// react-native-svg types omit `style` on <Path>, but its web renderer forwards
// it to the DOM <path>, where mix-blend-mode applies. Native ignores it, as it
// did when this was a .svg.
const multiplyBlend = { style: { mixBlendMode: 'multiply' as const } };

export const WinnerIsometric1 = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg width={49} height={38} fill='none' viewBox='0 0 49 38' {...props}>
      <Path
        fill='#00D9A5'
        d='M23.8 35.9 1.782 22.863c-.7-.394-1.302-1.04-.618-1.466L23.26 8.633c.332-.206.836-.341 1.172-.145l23.111 13.444c.701.407.827 1.546.123 1.955L26.705 35.879a2.92 2.92 0 0 1-2.906.02'
      />
      <Path
        fill={`url(#${uid}-a)`}
        d='m32.101 29.518-3.395 1.773 1.45 1.006 3.34-1.952c-.283-.184-1.108-.648-1.395-.827'
        opacity={0.63}
        {...multiplyBlend}
      />
      <Path
        fill={`url(#${uid}-b)`}
        d='m10.762 21.209-2.75 1.436 1.175.817 2.573-1.696c-.232-.148-.766-.41-.998-.557'
        opacity={0.63}
        {...multiplyBlend}
      />
      <Path
        fill={`url(#${uid}-c)`}
        d='m22.562 24.229-6.044 2.903 5.228 3.06 5.204-3.14a405 405 0 0 0-4.388-2.823'
        opacity={0.63}
        {...multiplyBlend}
      />
      <Path
        fill='#FA6C00'
        d='M27.02 24.23s.62.737.678 1.133c.058.395.015 2.35-3.43 2.331-3.444-.018-3.219-2.102-3.161-2.26.057-.159.781-1.33.781-1.33'
      />
      <Path
        fill='#F7DD02'
        d='M24.424 26.085c1.468 0 2.658-.683 2.658-1.527s-1.19-1.526-2.658-1.526-2.658.683-2.658 1.526c0 .844 1.19 1.527 2.658 1.527'
      />
      <Path
        fill='#FA6C00'
        d='M27.807 20.337c.97-.687 2.45.454 3.483.49.702.028 1.225-.263 1.487-.93.108-.277.257-.702.245-1.006-.015-.407-.348-.655-.627-.896-.87-.75-2.14-1.023-2.864-1.928-.342-.427.26-1.038.606-.607.64.8 1.825 1.092 2.624 1.729.378.302.834.658 1.023 1.12.188.46.053 1.03-.08 1.5-.262.935-.836 1.684-1.837 1.841-.49.066-.988.03-1.463-.105-.327-.085-.644-.204-.964-.31a9 9 0 0 0-.43-.132 3 3 0 0 0-.218-.056q-.289-.122-.308.349c.542.107.313.935-.227.828-.886-.173-1.232-1.329-.45-1.887M16.93 7.89c.56.153 1.116.597 1.592.915.52.348 1.018.723 1.508 1.11.432.344-.178.948-.607.608a18 18 0 0 0-2.265-1.566c-.197-.113-.46-.38-.68-.148-.13.136-.114.45-.109.613.028.428.123.849.28 1.247.595 1.627 1.9 2.856 3.121 4.024.4.383-.207.99-.606.608-1.628-1.558-3.484-3.389-3.648-5.782-.058-.838.398-1.908 1.413-1.63'
      />
      <Path
        fill='#FEC617'
        d='M25.07 21.713s-.109 1.03.233 1.663q.263.5.595.957s.091 1.03-1.515 1.03-1.335-.994-1.335-.994a3.18 3.18 0 0 0 .577-2.658'
      />
      <Path
        fill='#FFA407'
        d='M23.05 24.369a3.18 3.18 0 0 0 .576-2.658h.49c-.032 1.228.035 2.67.82 3.603a3 3 0 0 1-.546.049c-1.611 0-1.34-.994-1.34-.994'
      />
      <Path
        fill='#FEC617'
        d='M30.135 11.558v4.384s-.075 5.991-5.723 5.991c-5.649 0-5.472-6.04-5.472-6.04v-4.335'
      />
      <Path
        fill='#FFA407'
        d='M18.935 15.892v-4.334h3.237c-.027 2.822.131 5.952 1.96 8.194a8 8 0 0 0 2.258 1.888c-.64.202-1.308.3-1.978.293-5.652-.001-5.477-6.04-5.477-6.04'
      />
      <Path
        fill='#F7DD02'
        d='M24.532 14.863c3.09 0 5.597-1.48 5.597-3.305s-2.506-3.305-5.597-3.305-5.597 1.48-5.597 3.305 2.505 3.305 5.597 3.305'
      />
      <Path
        fill='#FA6C00'
        d='M24.407 14.086c2.578 0 4.668-1.17 4.668-2.615s-2.09-2.616-4.668-2.616-4.669 1.171-4.669 2.616c0 1.444 2.09 2.615 4.669 2.615'
      />
      <Path
        fill='#EEA7B7'
        d='M29.155 17.181s.056-.708 0-.756-.16.123-.17.226c0 0-.096-.217-.175-.193-.08.025-.45.246-.443.419s.458.676.458.676M36.055 15.733s-.367-.305-.33-.41c.039-.104.246.144.246.144s-.088-.392.016-.432.49-.092.532-.017c.041.074-.067.715-.067.715M32.482 25.219s.26 1.479.307 2.032.062 2.011.062 2.011a.5.5 0 0 0 .598.231q.174-1.121.153-2.257c-.047-1.028.007-2.488.007-2.488zM33.81 24.872s.261.83.537.981c.275.153 2.855.88 3.62 1.738 0 0 .537-.111.507-.455 0 0-.613-.558-1.288-1.05-.675-.49-1.998-.674-2.064-.782s-.173-1.517-.173-1.517'
      />
      <Path
        fill='#5311A6'
        d='M34.545 19.442s1.592 1.703.54 5.68c0 0-1.339.49-2.605.098 0 0-1.113-3.515.137-5.331'
      />
      <Path
        fill='#18A87D'
        d='M33.478 16.408c0-.044.102-.287-.075-.386-.176-.1-.905-.105-.905.059s.123.357 0 .43c-.122.074-.638.044-.83.224-.193.179-1.381 1.874-1.707 1.74s-.758-1.438-.758-1.438l-.538.383s.104 1.68.89 2.037c.787.357 2.628-1.264 2.628-1.264s.49 1.22.433 1.695c-.058.474 1.982.198 1.927-.446-.06-.697.133-1.8.133-1.8s1.706.73 2.242.164c.535-.566-.413-2.215-.413-2.215l-.505.134s.386 1.249.178 1.337c-.208.089-1.289-.729-1.899-.758s-.8.104-.8.104'
      />
      <Path
        fill='#4501A4'
        d='M32.848 29.136s-.123.457-.367.383c-.245-.073-.498-.253-.591-.16-.093.094-.17.218-.047.358s.807.52.807.52l.426-.389s.023.614.07.621c.046.007.325.007.349-.123s0-1.143 0-1.143zM37.968 27.591s.22.146.111.34-.434.413-.411.513c.022.1.132.303.279.246.147-.058.396-.18.45-.288s.062-.736.122-.769.45.427.512.39c.063-.039.287-.258.245-.311-.042-.055-.807-.578-.807-.578l-.3-.264-.456.49z'
      />
      <Path
        fill='#5311A6'
        d='M32.17 15.301s-.356-.304-.276-.634a.947.947 0 0 1 1.102-.648c.634.105 1.121.714 1.096 1.652-.026.937-1.47.546-1.47.546'
      />
      <Path
        fill='#EEA7B7'
        d='M32.118 14.667s-.105 1.493.224 1.585c.33.092.554-.316.554-.316l.066-.278s.33-.304.092-.396a.284.284 0 0 0-.357.122s-.105-.304-.276-.224-.303-.494-.303-.494'
      />
      <Path
        fill='#FFBB8F'
        d='M11.875 13.684c.077.105.08.569 0 .62-.081.05-.173-.041-.173-.041s-.05.284-.132.284-.619-.263-.588-.498c.03-.234.313-.71.313-.71M18.267 5.009s.022-.585.096-.601c.073-.016.114.195.122.17.009-.024.13-.6.245-.613s0 .52 0 .52.421.081.446.245c.025.165-.518.593-.518.593'
      />
      <Path
        fill='#341A0C'
        d='M16.329 20.53s.026.483.285.665c.26.181.598.234.735.508a.49.49 0 0 1-.064.52 1.56 1.56 0 0 1-.962-.183c-.52-.273-.767-.43-.948-.469-.182-.039-.01-1.114-.01-1.114z'
      />
      <Path
        fill='#18A87D'
        d='M15.645 8.568s.482-.29.706-.614c.225-.324 1.916-2.945 1.916-2.945s.431 0 .553.19c.121.19-1.45 3.75-1.933 4.113s0 4.32-.245 4.684-2.1.728-2.584-.085l-.367-2.23s-1.622 1.729-1.744 2.108c0 0-.5-.017-.655-.45-.155-.431 2.347-3.871 2.778-4.286s1.575-.485 1.575-.485'
      />
      <Path
        fill='#341A0C'
        d='M16.068 7.766s.593-.257.434-.641c-.16-.384-.718-.687-1.47-.352s-.638.703-.527 1.087c.112.384.299.708.417.708s.45-.4.45-.4'
      />
      <Path
        fill='#FFBB8F'
        d='M16.023 7.412c.092-.032.096 1.551-.463 1.504-.559-.048-.613-.64-.613-.64s-.383-.223-.255-.384c.127-.16.383 0 .383 0l.095-.48s.247.209.853 0'
      />
      <Path
        fill='#5311A6'
        d='M16.645 13.996s1.027 2.476.869 3.215c-.159.738-1.134 3.695-1.134 3.695s-1.044-.133-1.009-.45c.035-.316.646-3.133.545-3.471-.132-.447-.497-1.701-.545-1.437s-.467 1.604-.812 2.026-2.94 2.46-2.94 2.46-.765-.554-.685-.791 1.925-1.518 2.24-2.27c.23-.548.895-3.061.895-3.061'
      />
      <Path
        fill='#341A0C'
        d='M11.612 20.035q-.111.326-.183.663c-.04.235.123.678.245.769.123.09.104.274-.065.39-.169.117-.676.052-.857-.13-.182-.182-.04-.524-.183-.822-.143-.299-.52-.868.376-1.527'
      />
      <Path
        fill='#FFAD4A'
        d='m21.559 14.955.517 1.612 1.219.851-.934.621.202 1.518-1.079-1.259-1.109.12.242-1.352-.863-1.495 1.228.425z'
      />
      <Path
        fill='#FFAD4A'
        d='m22.13 19.863.433-.306-.696-2.027-.308-2.575-.433.306-.414.918-.958-.608-.432.306'
      />
      <Path
        fill='#FFE14D'
        d='m21.126 15.26.517 1.612 1.219.852-.908.57.177 1.57-1.08-1.26-1.108.119.241-1.351-.862-1.495 1.229.425z'
      />
      <Path
        fill='white'
        d='M26.286 15.654s.272 1.505-1.214 1.505c0 0 1.183.36 1.215 1.157 0 0 .301-1.121 1.203-1.121 0-.004-1.204-.025-1.204-1.54M19.757 12.523s.166.921-.746.921c0 0 .726.221.746.712 0 0 .185-.69.735-.69.005.002-.735-.012-.735-.943'
      />
      <Path
        fill='#FEC617'
        d='M30.637 6.511s.33 1.818-1.47 1.818c0 0 1.432.434 1.47 1.403 0 0 .367-1.359 1.458-1.359 0 0-1.458-.026-1.458-1.862M24.398 3.994S24.67 5.5 23.184 5.5c0 0 1.183.36 1.215 1.157 0 0 .302-1.121 1.203-1.121 0-.005-1.204-.026-1.204-1.542'
      />
      <Path
        fill={`url(#${uid}-d)`}
        d='m15.612 21.288-4.63 2.419 1.978 1.372 4.33-2.856c-.385-.25-1.287-.691-1.678-.935'
        opacity={0.63}
        {...multiplyBlend}
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={30.023}
          x2={31.717}
          y1={32.563}
          y2={29.833}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='white' stopOpacity={0} />
          <Stop offset={0.99} stopColor='#754C24' />
        </LinearGradient>
        <LinearGradient
          id={`${uid}-b`}
          x1={9.004}
          x2={10.389}
          y1={23.634}
          y2={21.401}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='white' stopOpacity={0} />
          <Stop offset={0.99} stopColor='#754C24' />
        </LinearGradient>
        <LinearGradient
          id={`${uid}-c`}
          x1={20.014}
          x2={22.813}
          y1={29.878}
          y2={25.365}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='white' stopOpacity={0} />
          <Stop offset={0.99} stopColor='#754C24' />
        </LinearGradient>
        <LinearGradient
          id={`${uid}-d`}
          x1={12.65}
          x2={14.983}
          y1={25.368}
          y2={21.607}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='white' stopOpacity={0} />
          <Stop offset={0.99} stopColor='#754C24' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
